export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary-100 mb-6">
            <i className="ri-mail-send-line text-2xl text-primary-500"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">联系我们</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto mb-8 leading-relaxed">
            如果你有漫画投稿需求、商务合作意向或任何问题反馈，欢迎通过以下方式联系我们。迷妹漫画始终期待与创作者和合作伙伴携手，为漫画爱好者带来更优质的阅读体验。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <div className="flex items-center gap-3 px-5 py-3 bg-background-50 rounded-xl border border-background-200/70">
              <i className="ri-mail-line text-primary-500 text-lg"></i>
              <div className="text-left">
                <p className="text-xs text-foreground-500">投稿与合作</p>
                <p className="text-sm font-medium text-foreground-800">contact@mimeimanga.com</p>
              </div>
            </div>
            <div className="flex items-center gap-3 px-5 py-3 bg-background-50 rounded-xl border border-background-200/70">
              <i className="ri-question-answer-line text-primary-500 text-lg"></i>
              <div className="text-left">
                <p className="text-xs text-foreground-500">问题反馈</p>
                <p className="text-sm font-medium text-foreground-800">support@mimeimanga.com</p>
              </div>
            </div>
          </div>

          <a href="#faq" className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer">
            也可以先查看常见问答
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}